// Shared renderer for an operation trace. Used by the sandbox's trace panel
// and by every lesson demo, so a step looks and reads the same wherever the
// learner meets it.

import { Trace } from "../engine/trace";

export function renderTraceSteps(list: HTMLElement, trace: Trace): void {
  list.textContent = "";
  for (const s of trace.steps) {
    const li = document.createElement("li");
    li.className = `trace-step depth-${s.depth} comp-${s.component}`;
    const kind = document.createElement("span");
    kind.className = "step-kind";
    kind.textContent = s.kind;
    const detail = document.createElement("span");
    detail.className = "step-detail";
    detail.textContent = s.detail;
    li.append(kind, detail);
    if (s.cost) {
      const cost = document.createElement("span");
      cost.className = "step-cost";
      cost.textContent = s.cost;
      li.appendChild(cost);
    }
    list.appendChild(li);
  }
}
